import { GalleryPage } from './gallery.component';
import { connect } from 'react-redux';
import { fetchGallery } from "./../../api/gallery/galleryAction";

const mapDispatchToProps = {
    fetchGallery
};

const mapStateToProps = state => ({
    isLoading: state.galleryPage.isLoading,
    gallery: state.galleryPage.gallery
});

export const GalleryContainer = connect(mapStateToProps, mapDispatchToProps)(GalleryPage);